import { ReactElement, PropsWithChildren } from 'react'
import { Wrapper } from './ContentWrapper.styled'

// eslint-disable-next-line @typescript-eslint/ban-types
const ContentWrapper = ({ children }: PropsWithChildren<{}>): ReactElement => <Wrapper>{children}</Wrapper>

export default ContentWrapper
